import {useMemo} from 'react';

import {ILimitsFeesResponse} from '@/dataSource/src/api/payment-link/v2/models';
import {PaymentMethodType} from '@/dataSource/src/api/payment-link/v2/types';

import {getPaymentFee} from '../../utils/paymentFees';

type LimitFeeBoxProps = {
  receiverAmount: number;
  selectedMethod?: PaymentMethodType;
  limitsFees: ILimitsFeesResponse | undefined;
};

export function useActions({
  receiverAmount,
  selectedMethod,
  limitsFees,
}: LimitFeeBoxProps) {
  const feeAmount = useMemo<number>(
    () => getPaymentFee(receiverAmount, selectedMethod, limitsFees),
    [selectedMethod, limitsFees, receiverAmount],
  );
  const formattedReceive = useMemo(() => {
    if (!Number.isFinite(receiverAmount)) return 0;
    return receiverAmount?.toFixed(2);
  }, [receiverAmount]);

  const formattedFee = useMemo(() => {
    if (feeAmount == null) return 0;
    return feeAmount?.toFixed(2);
  }, [feeAmount]);

  const formattedTotal = useMemo(() => {
    if (!Number.isFinite(receiverAmount) || feeAmount == null) return 0;
    return (receiverAmount + feeAmount)?.toFixed(2);
  }, [receiverAmount, feeAmount]);

  return {
    formattedReceive,
    formattedFee,
    formattedTotal,
  };
}
